import React, { useCallback, useEffect, useState } from 'react'
import { HeaderPage } from '../../../components/HeaderPage'
import { SpinnerLoad } from '../../../components/Loading/SpinnerLoad'
import { NewOnboarding } from '../../../components/Onboarding/NewOnboarding'
import { OnboardingCard } from '../../../components/Onboarding/OnboardingCard'
import useApi from '../../../hooks/useApi'
import { Button } from '../../../Korbantech/components/Buttons/Button'
import Modal from '../../../Korbantech/components/Modal'
import { AdminLayout } from '../../../layout/AdminLayout'
import { Onboarding as Type } from '../../../types/Onboarding'


export const Onboarding = () => {

    const api = useApi()
    const [modal, setModal] = useState<boolean>()
    const [onboardings, setOnboardings] = useState<Type[]>([])
    const [load, setLoad] = useState<boolean>(false)

    const loadOnboardings = useCallback(async () => {
        setLoad(true)
        await api.get("/admin/onboarding").then(res => {
            setOnboardings(res.data)
        }).catch(console.log)
        setLoad(false)
    }, [setLoad, setOnboardings, api])

    useEffect(() => {
        loadOnboardings()
    }, [loadOnboardings])
    return (
        <AdminLayout>
            <HeaderPage name='Slides' button={<Button value="Adicionar Novo" onClick={() => setModal(true)} />} />
            <Modal open={modal} onClickCloseButton={() => setModal(false)}>
                <NewOnboarding />
            </Modal>
            {!load &&
                <div className='grid grid-cols-4 gap-x-4 gap-y-2'>
                    {onboardings.map(item => (
                        <div key={item.id}>
                            <OnboardingCard item={item} />
                        </div>
                    ))}
                </div>
            }
            {load && <SpinnerLoad />}

        </AdminLayout>
    )
}

